var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pageView",staticClass:"page-view"},[_c('div',{ref:"homeTitle",staticClass:"overview-title lottie"}),_c('router-view',{key:_vm.$route.fullPath}),_c('img',{staticClass:"page-footer",attrs:{"src":require("../assets/imgs/overview-bottom.png"),"alt":""}}),_c('div',{ref:"footer",staticClass:"footer-lottie"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }